import { render, staticRenderFns } from "./service_footer.vue?vue&type=template&id=12b45bba&scoped=true"
import script from "./service_footer.vue?vue&type=script&lang=js"
export * from "./service_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b45bba",
  null
  
)

export default component.exports